export const checkUserModuleComponentEnabled = (modules, moduleName, componentName = null) => {
  try {
    // Module check
    const matchingModule = modules.find(
      (module) =>
        module.Module.module_name === moduleName && module.FK_modules_components_id === null
    );
    let enabled = matchingModule ? matchingModule.enabled : true;

    // Component check
    if (enabled && componentName) {
      const matchingComponent = modules.find(
        (component) =>
          component.Module.module_name === moduleName &&
          component.ModulesComponent?.component_name === componentName
      );
      enabled = matchingComponent ? matchingComponent.enabled : true;
    }
    return enabled;
  } catch {
    return false;
  }
};

export const checkUserModuleComponentEnabledById = (modules, moduleId, componentId = null) => {
  try {
    // Module check
    const matchingModule = modules.find(
      (module) =>
        module.Module.FK_modules_id === moduleId && module.FK_modules_components_id === null
    );
    let enabled = matchingModule ? matchingModule.enabled : true;

    // Component check
    if (enabled && componentId) {
      const matchingComponent = modules.find(
        (component) =>
          component.FK_modules_id === moduleId && component.FK_modules_components_id === componentId
      );
      enabled = matchingComponent ? matchingComponent.enabled : true;
    }
    return enabled;
  } catch {
    return false;
  }
};
